///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthAbstractCommand } from '../../abstract-command';

export class GtthActivateLayerCommand extends GtthAbstractCommand {
    private activatedLayer: number;

    getCommandName(): string {
        return 'GtthActivateLayerCommand';
    }

    create(activatedLayer: number): this {
        this.activatedLayer = activatedLayer;
        return this;
    }

    doCommand(): void {
        this.historyService.logicalTopology.activeLayerIdx = this.activatedLayer;

        this.historyService.logicalTopology.changeSectorsLinksColor();
        this.historyService.logicalTopology.stationsChangeDraggable();
        this.historyService.logicalTopology.changeStationIcons();

        this.historyService.clearSelectionCloseWindowAndArea();

        this.historyService.projectInfoViewService.setNumberOfConnectedTu(
            this.historyService.logicalTopology.getConnectedTerminalStationsCount()
        );

        // return false as this command will not be stored in history
        this.commandResolve(false);
    }
}
